import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2';
 
  import { API_URL,isEmpty,ShowSwallError,SwalBlokUI,SwalUnBlokUI,SendPasswordByMail} from '../../config'
 
// import $ from 'jquery'
import Login from './Login'
class Forgotpassword extends Component {

    constructor() {
        super();
        this.state = {
            login_id: "" 
          };
          this.onInputchange = this.onInputchange.bind(this);
    }
  
    onInputchange(event) {
        this.setState({
          [event.target.name]: event.target.value
        });
      }
      componentDidMount(){  
          console.clear() 
      }
SendForgotPasswordLink(){
   
    if(isEmpty(this.state.login_id))
    {
        ShowSwallError("Please Enter User Id")
        return false;
    }
    SendPasswordByMail(this.state.login_id);
    
    
}
    

    render() {
 
        return (
 
        <div className="index_bg">
        <div className="content-overlay"></div>
        <div className="header-navbar-shadow"></div>
        <div className="content-wrapper">
            <div className="content-header row">
            </div>
            <div className ="content-body">
                <div className="auth-wrapper auth-v1 px-2">
                    <div className="auth-inner py-2">
                       
                        <div className="card mb-0">
                            <div className="card-body">
                                <a href="#" className="brand-logo">
                                    
                                            <img className="w-50"  src="../../../app-assets/images/pages/Weikfield-RGB-02.png" alt=""/>
                                </a>

                                <h4 className="card-title mb-1">Forgot Password? 🔒</h4>
                                <p className="card-text mb-2">Enter your Login Id and we'll send the Password to your Mail Id</p>

                              
                                    <div className="form-group">
                                        <label htmlFor="forgot-password-email" className="form-label">Login Id</label>
                                        <input type="text"   name="login_id" value={this.state.fname} onChange={this.onInputchange} className="form-control" 
                                        placeholder="Login Id" aria-describedby="forgot-password-email" tabIndex="1"   />
                                    </div>
                                    <button className="btn btn-primary btn-block" tabIndex="2" onClick={()=>this.SendForgotPasswordLink()} >Send reset link.</button>
                              
                                <p className="text-center mt-2">
                                    <a    href="/"> <i data-feather="chevron-left"></i> Back to login </a>
                                </p>
                            </div>
                        </div>
                        
                    </div>
                </div>

            </div>
        </div>
    </div>
            


        );


    }
}
export default Forgotpassword
